import { WebAPICallResult } from './models';

export enum ErrorCode {
  LambdaError = 'lambdaError',
  ApiError = 'apiError',
}

export type WebAPICallError = WebAPIPlatformError | WebAPILambdaError;

export interface CodedError extends Error {
  code: ErrorCode;
}

export interface WebAPIPlatformError extends CodedError {
  code: ErrorCode.ApiError;
  /** The runtime didn't handle the error. For example, the function ran out of memory or timed out. */
  unhandled: boolean;
  data: WebAPICallResult & {
    error: {
      type: string;
    }
  };
}

export interface WebAPILambdaError extends CodedError {
  code: ErrorCode.LambdaError;
  original: Error;
}

function errorWithCode(error: Error, code: ErrorCode): CodedError {
  // NOTE: might be able to return something more specific than a CodedError with conditional typing
  const codedError = error as Partial<CodedError>;
  codedError.code = code;
  return codedError as CodedError;
}



export function platformErrorFromResult(errorPayload: string, functionError: string): WebAPIPlatformError {
  const parsedError: {errorType: string, errorMessage: string} = JSON.parse(errorPayload);
  const error = errorWithCode(
    new Error(`An API error occurred: [${parsedError.errorType}] ${parsedError.errorMessage}`),
    ErrorCode.ApiError,
  ) as Partial<WebAPIPlatformError>;

  error.data.error.type = parsedError.errorType;
  try {
    const errorData = JSON.parse(parsedError.errorMessage);
    error.data.error.data = errorData;
  } catch (e) {
    error.data.error.message = parsedError.errorMessage;
  }
  error.unhandled = functionError === 'Unhandled';
  return (error as WebAPIPlatformError);
}

export function lambdaErrorFromResult(original: Error): WebAPILambdaError {
  const error = errorWithCode(
    new Error(`A Lambda error occurred: [${original.name}] ${original.message}`),
    ErrorCode.LambdaError,
  ) as Partial<WebAPILambdaError>;
  error.original = original;
  return (error as WebAPILambdaError);
}
